import { supabase } from '@/integrations/supabase/client';

export type AuditAction =
  | 'auth.sign_in'
  | 'auth.sign_up'
  | 'auth.sign_out'
  | 'evaluation.run'
  | 'evaluation.save_session'
  | 'action.execute'
  | 'action.dismiss'
  | 'repair.apply'
  | 'repair.run'
  | 'rule.create'
  | 'rule.update'
  | 'rule.delete'
  | 'api_key.created'
  | 'api_key.revoked'
  | 'notification.trigger_fired';

export type AuditResourceType =
  | 'auth'
  | 'evaluation'
  | 'session'
  | 'trigger'
  | 'signal'
  | 'score'
  | 'repair'
  | 'execution'
  | 'api_key';

interface AuditEntry {
  action: AuditAction;
  resource_type: AuditResourceType;
  resource_id?: string;
  metadata?: Record<string, unknown>;
}

/** Log an auditable action via edge function. Non-blocking — failures are silently ignored. */
export async function logAudit(entry: AuditEntry): Promise<void> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.user) return;

    await supabase.functions.invoke('audit-log', {
      body: {
        action: entry.action,
        resource_type: entry.resource_type,
        resource_id: entry.resource_id ?? null,
        metadata: entry.metadata ?? {},
      },
    });
  } catch {
    // Audit logging is non-blocking — don't break UX
  }
}
